import { render, staticRenderFns } from "./UiPageToolbar.vue?vue&type=template&id=1995fb66&scoped=true"
import script from "./UiPageToolbar.vue?vue&type=script&lang=js"
export * from "./UiPageToolbar.vue?vue&type=script&lang=js"
import style0 from "./UiPageToolbar.vue?vue&type=style&index=0&id=1995fb66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1995fb66",
  null
  
)

export default component.exports